import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import styles from './styles/kitchen-accordion.module.css'

const KitchenAccordion = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.accordion}>
      <button
        className={styles.accordionToggle}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span>Cabinet Customization Options</span>
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </button>

      {isOpen && (
        <div className={styles.accordionContent}>
          <img src="https://ik.imagekit.io/1stopkitchens/images/partners/triangle_logo_light.png" alt="Triangle Kitchen Logo" loading="lazy" />
          <p>
              We offer <strong>custom paint and stain finishes</strong> to match your vision exactly.
          </p>
          <p>
            Our cabinets are supplied by a trusted <strong>local dealer</strong>. Triangle Kitchen is based in Dieppe, New Brunswick. You can explore all their door styles and finish options on their website:
          
            👉&nbsp;<a href="https://trianglekitchen.com/products/styles" target="_blank" rel="noopener noreferrer" className={styles.dealerLink}>
              View Cabinet Options
            </a>
          </p>
          <p>
            All our cabinets come with a <strong>limited warranty</strong> to ensure lasting quality and peace of mind. For full details, visit the <a href="https://trianglekitchen.com/learning-centre/warranty-information-0" target="_blank" rel="noopener noreferrer" className={styles.dealerLink}>warranty page</a>.
          </p>
        </div>
      )}
    </div>
  );
};

export default KitchenAccordion;
